import image1 from '../../../../assets/images/StockAnalysis/image-1.svg'
import image2 from '../../../../assets/images/StockAnalysis/image-2.svg'
import image3 from '../../../../assets/images/StockAnalysis/image-3.svg'
import iconInfo from '../../../../assets/images/StockAnalysis/icon-info.svg'

import './BoxItemStock.scss'
import { Popover } from 'antd'
import { useEffect, useState } from 'react'
import usePortfolio from 'hook/usePortfolio'
import { useSelector } from 'react-redux'

export default function BoxItemStock() {
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore);
  const PortfolioStore = useSelector((state: any) => state?.PortfolioStore);
  const { fetchPortfolio } = usePortfolio();

  useEffect(() => {
    if (StocksAnalysisStore?.inputSearch) {
      fetchPortfolio(StocksAnalysisStore?.inputSearch)
    }

  }, [StocksAnalysisStore?.inputSearch])

  const content1 = () => {
    return <div className='qsqwgxjkhp'>
      <div className='wuwkaqrace'>Thỏa mãn tiêu chí:</div>
      <div className='uxpbfipwfo'>
        <ul className='yiuibcyivo'>
          <li className='rwtsawzfqv'>Trong đà tăng trưởng về giá và khối lượng. Có xác suất tạo lợi nhuận ngắn hạn cao</li>
          <li className='rwtsawzfqv'>Dành cho nhà đầu tư ưa thích lướt sóng cổ phiếu<br />
            Thời gian khuyến nghị nắm giữ: 0.5-1 tháng</li>
        </ul>
      </div>
    </div>
  }

  const content2 = () => {
    return <div className='qsqwgxjkhp'>
      <div className='wuwkaqrace'>Thỏa mãn tiêu chí:</div>
      <div className='uxpbfipwfo'>
        <ul className='yiuibcyivo'>
          <li className='rwtsawzfqv'>Giá cổ phiếu giữ xu hướng trung hạn, doanh nghiệp tiềm năng. <br />
            Dành cho nhà đầu tư ưa thích nắm giữ cổ phiếu của doanh nghiệp đang trong đà tăng trưởng.</li>
          <li className='rwtsawzfqv'>Thời gian khuyến nghị nắm giữ: 1-6 tháng.</li>
        </ul>
      </div>
    </div>
  }

  const content3 = () => {
    return <div className='qsqwgxjkhp'>
      <div className='wuwkaqrace'>Thỏa mãn tiêu chí:</div>
      <div className='uxpbfipwfo'>
        <ul className='yiuibcyivo'>
          <li className='rwtsawzfqv'>Giá cổ phiếu chiết khấu sâu so với mặt bằng định giá trong quá khứ,
            nhưng doanh nghiệp vẫn hoạt động hiệu quả.<br />
          </li>
          <li className='rwtsawzfqv'>Dành cho nhà đầu tư ưa thích đầu tư giá trị.<br />
            Nắm giữ: 6-36 tháng</li>
        </ul>
      </div>
    </div>
  }

  const soon = () => {
    return (
      <div style={{ color: '#ffffff' }}>
        Tính năng sắp ra mắt
      </div>
    )
  }

  return (
    <>
      <div className='kqrncduisp'>
        <div className='xeojdvhryk'>Nằm trong danh mục</div>
        <div className='husznvteic'>
          {/* wjeuizczmo */}
          <div className={`ebmkpjlhxw`}>
            {/* <div className={`ebmkpjlhxw ${PortfolioStore?.portfolio?.shortTerm ? 'wjeuizczmo' : ''}`}> */}
            <div className='ffezhslqrh'><img className='jwganixzao' alt='' src={image1} /></div>
            <div className='bqjhadparu'>
              DSC ngắn hạn  <Popover placement="bottom" title={''} color="#131313" content={soon} trigger="hover">
                <img className='pgqcmifmng' alt='' src={iconInfo} />
              </Popover></div>
            <div className='biuolzvaqg'>Danh mục cổ phiếu tăng trưởng giá mạnh mẽ.</div>
          </div>
          <div className={`ebmkpjlhxw`}>
            {/* <div className={`ebmkpjlhxw ${PortfolioStore?.portfolio?.midTerm ? 'wjeuizczmo' : ''}`}> */}
            <div className='ffezhslqrh'><img className='jwganixzao' alt='' src={image2} /></div>
            <div className='bqjhadparu'>
              DSC Trung hạn <Popover placement="bottom" title={''} color="#131313" content={soon} trigger="hover">
                <img className='pgqcmifmng' alt='' src={iconInfo} />
              </Popover></div>
            <div className='biuolzvaqg'>Danh mục cổ phiếu cơ bản duy trì đà tăng ổn định.</div>
          </div>
          <div className={`ebmkpjlhxw`}>
            {/* <div className={`ebmkpjlhxw ${PortfolioStore?.portfolio?.longTerm ? 'wjeuizczmo' : ''}`}> */}
            <div className='ffezhslqrh'><img className='jwganixzao' alt='' src={image3} /></div>
            <div className='bqjhadparu'>
              DSC Dài hạn <Popover placement="bottom" title={''} color="#131313" content={soon} trigger="hover">
                <img className='pgqcmifmng' alt='' src={iconInfo} />
              </Popover></div>
            <div className='biuolzvaqg'>Danh mục cổ phiếu có mức giá rẻ phù hợp đầu tư giá trị.</div>
          </div>
        </div>
      </div>
    </>
  )
}